import {
  FETCH_PICKUP_TIME,
  FETCH_PICKUP_TIME_SUCCESS,
  FETCH_PICKUP_TIME_ERROR,
  UPDATE_PICKUP_TIME,
  UPDATE_PICKUP_TIME_SUCCESS,
  UPDATE_PICKUP_TIME_ERROR,
  FETCH_RESTAURANTS_STATUSSES,
  FETCH_RESTAURANTS_STATUSSES_SUCCESS,
  FETCH_RESTAURANTS_STATUSSES_ERROR,
  UPDATE_RESTAURANT_STATUS,
  UPDATE_RESTAURANT_STATUS_SUCCESS,
  UPDATE_RESTAURANT_STATUS_ERROR,
  GET_RESTAUANT_SEND_TO_POS_SUCCESS,
  FETCH_BUSY_MODES_SUCCESS,
  SET_BUSY_MODE_ERROR,
  EDIT_RETRY_COUNT,
  FETCH_RETRY_COUNT_SUCCESS,
  SET_STORE_AUTO_OPEN,
} from "./types/actionTypes";

const initialState = {
  pickupTime: 0,
  restaurantsSendToPos: [],
  currLocation: localStorage.getItem("currLocation") || "",
  loading: false,
  pageCount: 1,
  retryCount: 1,
};

const settingsReducer = (state = initialState, action: any): any => {
  switch (action.type) {
    case FETCH_PICKUP_TIME:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PICKUP_TIME_SUCCESS:
      return {
        ...state,
        pickupTime: action.payload.data,
        loading: false,
      };
    case FETCH_PICKUP_TIME_ERROR:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PICKUP_TIME:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PICKUP_TIME_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PICKUP_TIME_ERROR:
      return {
        ...state,
        loading: false,
      };
    case FETCH_RESTAURANTS_STATUSSES:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RESTAURANTS_STATUSSES_SUCCESS:
      return {
        ...state,
        restaurants: action.payload.data,
        pageCount: action.payload.page_count,
        loading: false,
      };
    case FETCH_RESTAURANTS_STATUSSES_ERROR:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_RESTAURANT_STATUS:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_RESTAURANT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_RESTAURANT_STATUS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case GET_RESTAUANT_SEND_TO_POS_SUCCESS:
      return {
        ...state,
        restaurantsSendToPos: action.payload,
      };
    case FETCH_BUSY_MODES_SUCCESS:
      return {
        ...state,
        busyModes: action.payload.data,
      };
    case SET_BUSY_MODE_ERROR:
      return {
        ...state,
        loading: false,
      };
    case EDIT_RETRY_COUNT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RETRY_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        retryCount: action.payload.data,
      };
    case SET_STORE_AUTO_OPEN:
      return {
        ...state,
        autoOpenModes: action.payload.data
      }
    default:
      return state;
  }
};

export default settingsReducer;
